// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1h0JM","noInteraction":"EventWrapper_noInteraction__3ed7q","pointerPassthrough":"EventWrapper_pointerPassthrough__2ZqHg"};